module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-image-2-800x533-6ab5a1f104f640ee93e6c253077650f8.jpg";